"use client";

import * as React from "react";
import * as Popover from "@radix-ui/react-popover";
import { Drawer } from "vaul";
import { useWalletInfoContext } from "../providers/wallet-info-provider";
import { WalletIcon } from "./icons";
import { shortenAddress } from "../../../lib/format";
import { cn } from "../../../lib/utils";

export interface WalletInfoTriggerProps {
  asChild?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function WalletInfoTrigger({
  asChild,
  className,
  children,
}: WalletInfoTriggerProps) {
  const { isMobile, theme, walletAddress } = useWalletInfoContext();

  const hasChildren = children != null;
  const shouldAsChild = asChild ?? true;

  const triggerContent = hasChildren ? (
    children
  ) : (
    <button
      type="button"
      className={cn("wi-trigger-btn", className)}
      data-theme={theme}
      data-mobile={isMobile || undefined}
    >
      <WalletIcon size={isMobile ? 14 : 16} />
      <span className="wi-trigger-address">
        {shortenAddress(walletAddress)}
      </span>
    </button>
  );

  if (isMobile) {
    return (
      <Drawer.Trigger asChild={shouldAsChild}>{triggerContent}</Drawer.Trigger>
    );
  }

  return (
    <Popover.Trigger asChild={shouldAsChild}>{triggerContent}</Popover.Trigger>
  );
}
